export default "__VITE_ASSET__ede5760f__"